module.exports = __webpack_public_path__ + "img/Crona-logo.147a6b09.png";